<template>
  <div class="edit-video-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="420px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="params" :rules="rules" label-width="100px">
        <el-form-item label="展示内容:" prop="title">
          <el-input type="textarea" v-model="params.title" size="small" placeholder="请输入展示内容"></el-input>
        </el-form-item>
        <el-form-item label="关键词:" prop="searchKeyword">
          <el-input v-model="params.searchKeyword" size="small" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="params.type" placeholder="请选择类型" size="small" >
            <el-option v-for="item in types" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跳转方式" prop="linkType">
          <el-select v-model="params.linkType" placeholder="请选择跳转方式" size="small">
            <el-option v-for="item in linkTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跳转链接" v-if="params.linkType == 2">
          <el-select v-model="params.link" placeholder="请选择链接地址" size="small" >
            <el-option v-for="item in linkLinks" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跳转链接:" prop="link" v-else>
          <el-input
            v-model="params.link"
            size="small"
            placeholder="请输入跳转链接"
          ></el-input>
        </el-form-item>
        <el-form-item label="内链ID:" prop="inLinkId"
          v-if="params.link == 'yinseinner://cartoonDetails?id=' ||
              params.link == 'yinseinner://comicsDetails?id=' ||
              params.link == 'yinseinner://postDetails?id='">
          <el-input size="small" v-model="inLinkId"></el-input>
        </el-form-item>
        <el-form-item label="状态:">
          <el-switch v-model="params.enabled"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('form')"
          :loading="flag"
          size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
export default {
  data() {
    return {
      title: "",
      dialogVisible: false,
      flag: false,
      type: "",
      id: "",
      params: {
        type: undefined,
        linkType: undefined,
        title: undefined,
        searchKeyword: undefined,
        link: undefined,
        enabled: false,
      },
      types: [],
      inLinkId: '',
      linkTypes: [],
      linkLinks: [
        { label: "专题", value: "yinseinner://topic_page" },
        { label: "福利", value: "yinseinner://welfare_page" },
        { label: "热榜", value: "yinseinner://hot_ranking_page" },
        { label: "会员", value: "yinseinner://vip_page" },
        { label: "金豆", value: "yinseinner://coin_page" },
        { label: "签到", value: "yinseinner://SigninPage" },
        { label: "跳转动漫详情", value: "yinseinner://cartoonDetails?id=" },
        { label: "跳转漫画详情", value: "yinseinner://comicsDetails?id=" },
        { label: "跳转帖子详情", value: "yinseinner://postDetails?id=" },
      ],
      // 验证规则
      rules: {
        title: [{ required: true, message: "请输入展示内容", trigger: "blur" }],
        searchKeyword: [{ required: true, message: "请输入关键词", trigger: "blur" }],
        type: [{ required: true, message: "请选择跳转方式", trigger: "blur" }],
        linkType: [{ required: true, message: "请选择类型", trigger: "blur" }],
        link: [{ required: true, message: "请输入跳转链接", trigger: "blur" }],
      }
    };
  },

  methods: {
    // 数据提交验证
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.flag = true;
          if (this.type === "add") {
            this.add();
          } else {
            this.edit();
          }
        } else {
          return false;
        }
      });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        type: undefined,
        linkType: undefined,
        title: undefined,
        searchKeyword: undefined,
        link: undefined,
        enabled: false,
      };
      this.inLinkId = '';
      this.$refs.form.resetFields();
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data, linkTypes, types) {
      this.dialogVisible = true;
      this.type = type;
      this.linkTypes = linkTypes;
      this.types = types;
      this.inLinkId = '';
      if (type === "edit") {
        this.title = "编辑快捷搜索";
        this.params.title = data.title;
        this.params.searchKeyword = data.searchKeyword;
        this.params.enabled = data.enabled;
        this.params.type = data.type;
        this.params.linkType = data.linkType;
        this.id = data.id;
        // 处理内部链接回显
        if (data.link.indexOf("movieDetails") !== -1||
        data.link.indexOf("personal") !== -1||
        data.link.indexOf("postDetails") !== -1) {
          const splitArr = data.link.split("=");
          this.params.link = splitArr[0] + "=";
          this.inLinkId = splitArr[1];
        } else {
          this.params.link = data.link;
        }
      } else {
        this.title = "新增快捷搜索";
      }
    },
    // 新增
    add() {
      if ((this.params.link == 'yinseinner://cartoonDetails?id=' ||
          this.params.link == 'yinseinner://comicsDetails?id=' ||
          this.params.link == 'yinseinner://postDetails?id=') && !this.inLinkId ) {
        this.$message({ type: "error", message: "请输入内链ID" });
        return;
      }
      if (this.params.link == 'yinseinner://cartoonDetails?id=' ||
          this.params.link == 'yinseinner://comicsDetails?id=' ||
          this.params.link == 'yinseinner://postDetails?id=') {
        this.params.link = this.params.link + this.inLinkId;
      }
      API.addQuickSearch(this.params)
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: "新增成功！",
              type: "success"
            });
            this.$emit("handlerList");
          } else {
            this.$message.error("新增失败！");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    // 编辑快捷搜索
    edit() {
      if ((this.params.link == 'yinseinner://cartoonDetails?id=' ||
          this.params.link == 'yinseinner://comicsDetails?id=' ||
          this.params.link == 'yinseinner://postDetails?id=') && !this.inLinkId ) {
        this.$message({ type: "error", message: "请输入内链ID" });
        return;
      }
      if (this.params.link == 'yinseinner://cartoonDetails?id=' ||
          this.params.link == 'yinseinner://comicsDetails?id=' ||
          this.params.link == 'yinseinner://postDetails?id=') {
        this.params.link = this.params.link + this.inLinkId;
      }
      this.params = Object.assign(this.params, { id: this.id });
      API.editQuickSearch(this.params)
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: "操作成功！",
              type: "success"
            });
            this.$emit("handlerList");
          } else {
            this.$message.error("操作失败！");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-video-box {
  .el-input {
    width: 240px;
  }
  .avatar-uploader {
    width: 200px;
    height: 200px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
